import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";

import { SettingsOutletLayout } from "~/providers/components/providerSettings/SettingsOutletLayout";
import { IntegrationCards } from "~/providers/components/tools/IntegrationCards";

const ZOOM_APP_OAUTH_TOAST_ID = "zoom-app-oauth-result";

export const IntegrationsScreen = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const zoomAppStatus = searchParams.get("zoom_app");
    if (!zoomAppStatus) return;

    if (zoomAppStatus === "connected") {
      toast.success("Zoom App connected successfully.", {
        toastId: ZOOM_APP_OAUTH_TOAST_ID,
      });
    } else if (zoomAppStatus === "error") {
      const reason = searchParams.get("reason");
      toast.error(
        reason
          ? `Unable to connect Zoom App (${reason}). Please try again.`
          : "Unable to connect Zoom App. Please try again.",
        { toastId: ZOOM_APP_OAUTH_TOAST_ID },
      );
    }

    const next = new URLSearchParams(searchParams);
    next.delete("zoom_app");
    next.delete("reason");
    setSearchParams(next, { replace: true });
  }, [searchParams, setSearchParams]);

  return (
    <SettingsOutletLayout>
      <IntegrationCards />
    </SettingsOutletLayout>
  );
};
